export const RETRIEVE_FILES_FORMATS = ['VMS_UMS', 'DMAU', 'MAINTENANCE', 'FDCR']
export const RETRIEVE_FILES_FORMATS_MW = ['VMS_UMS', 'FDCR']
export const RETRIEVE_FILES_FORMATS_EC225 = ['HUMS', 'HEALTH RAW DATA', 'FDCR']